import React from "react";
import { gql } from "graphql-tag";
import { useQuery } from "@apollo/client";
import css from "classnames";
import { getTeamByOrgId, getTeamByOrgIdVariables, UserRole } from "types/gql-types";
import { LinkButton } from "components/haven-design/buttons";
import { ServerError, LoadingSpinner } from "components/graphql-views";
import { authorizeForRole } from "components/auth/authorize-for-role";
import { Viewer } from "components/auth/types";
import { SettingsHeader } from "../settings-header";
import TeamTable from "./team-table";
import styles from "./team-table.module.css";


export const TEAM_BY_ORG = gql`
  query getTeamByOrgId($id: ID!) {
    organization(id: $id) {
      id
      name
      team {
        id
        fullName
        email
        roles
        directPhone
        title
        isArchived
      }
    }
  }
`;

type Props = {
  viewer: Viewer;
}

const TeamSettingsPage: React.FC<Props> = (props: Props) => {
  const orgId = props.viewer.organizationId;
  if (!orgId) return <ServerError desc="Missing Data" />;
  const { data, loading, error } = useQuery<getTeamByOrgId, getTeamByOrgIdVariables>(TEAM_BY_ORG, {
    fetchPolicy: "cache-and-network",
    variables: { id: orgId },
  });

  if (error) return <ServerError desc={error.message} />;
  if (loading) return <LoadingSpinner />;
  if (!data) return <ServerError desc="Missing Data" />;
  const { organization: { team: users } } = data;

  return (
    <div style={{ width: "100%" }}>
      <div className={css(styles.header, "margin-bottom-l")}>
        <SettingsHeader title="Team Settings" />
        <div className={styles.buttons}>
          <LinkButton
            to="/dash/manager/settings/team/new"
            size="L"
            color="primary"
          >
            Invite
          </LinkButton>
        </div>
      </div>
      <TeamTable rowData={users} />
    </div>

  );
};

export default authorizeForRole([UserRole.SUPERVISOR], TeamSettingsPage);
